module.exports = __webpack_public_path__ + "static/media/img-goal-5.7ae7754d.jpg";